export const version = "wallet/5.0.9";
//# sourceMappingURL=_version.js.map